import type { FlightCaseDefinition } from "../products/FlightCaseDefinition";

export enum LTProducts {
  Koffer = "koffer",
  KeyboardCase = "keyboardcase",
  Haube = "haube",
  Truhe = "truhe",
  Case3d = "case3d",
  LCase = "lcase",
  SingleDoor = "singledoor",
  DoubleDoor = "doubledoor",
}
export type ProductConstructors = {
  [key in LTProducts]: typeof FlightCaseDefinition;
};

export type LTProductOption = {
  value: LTProducts | string;
  label: string;
};

export const LTProductLabels: Record<LTProducts, string> = {
  [LTProducts.Koffer]: "Koffer",
  [LTProducts.KeyboardCase]: "Keyboard-Case",
  [LTProducts.Haube]: "Haube",
  [LTProducts.Truhe]: "Truhe",
  [LTProducts.Case3d]: "3D-Case",
  [LTProducts.LCase]: "L-Case",
  [LTProducts.SingleDoor]: "Single-Door-Case",
  [LTProducts.DoubleDoor]: "Double-Door-Case",
};

export function getLTProductLabel(productType: string): string {
  const normalized = productType.trim();
  if (!normalized) return "";
  return LTProductLabels[normalized as LTProducts] ?? normalized;
}

export function getLTProductOptions(
  extraTypes: readonly unknown[] = [],
): LTProductOption[] {
  const byValue = new Map<string, string>(Object.entries(LTProductLabels));

  for (const rawType of extraTypes) {
    if (typeof rawType !== "string") continue;
    const type = rawType.trim();
    if (!type || byValue.has(type)) continue;
    byValue.set(type, type);
  }

  return Array.from(byValue.entries())
    .map(([value, label]) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
